module.exports = __webpack_public_path__ + "img/collect.33a08182.png";